import { useCallback } from 'react';
import { getState } from 'src/redux/store';
import { $spacesCache } from 'src/services/spaces/spaces';
import { sequence } from 'src/utils/async-utils';
import { checkPageId } from '../page/check-page-id';
import { switchSpaceViewIdBySpaceId } from '../user/switch-space-view-id';
import { getCurrentSpace } from './use-current-space';

/**
 * 自动切换空间
 * 改完代码之后请验证一下这个链接的bug不会再出现哈
 * https://www.notion.so/Web-Sprint-11-91cc116ccd2d492c8a32baf948178ea3?p=7fb6b66f26a54289aaa7e503b3a0bd04
 */
export const useAutoSwitchSpace = () => {
  const switchSpaceByPageId = useSwitchSpaceByPageId();
  const autoSwitchSpace = (pageId: string) => {
    const { blocks } = getState();
    const block = blocks[pageId];
    if (block) {
      // 所有访问过的block都会保存，所以就算state上有数据，也需要对比一下当前block的spaceId跟实际是不是一致,不一致就需要切换一下空间【前进后退，可以自行切换空间】
      if (block.spaceId && block.spaceId !== getCurrentSpace().uuid) {
        switchSpaceViewIdBySpaceId(block.spaceId);
      }
    } else {
      // 这是一个没访问过的page，需要check一下是否需要切换空间
      void switchSpaceByPageId(pageId);
    }
  };
  return useCallback(autoSwitchSpace, [switchSpaceByPageId]);
};
/**
 * 当用户在浏览器输入链接的时候，会比原来多发送一个请求,木前在不造成bug的情况下，没有找到更好的解决方案.
 *
 * 考虑到一个使用场景:
 *
 * 同时打开ab2个窗口，a窗口切换空间之后，ab窗口可以分别继续访问自己页面所在空间的目录树,且本地存储的空间id还是a切换之后的空间id.
 *
 * 目前是支持上面描述的使用场景的
 */
const useSwitchSpaceByPageId = () => {
  return useCallback(async (pageId: string) => {
    const res = await sequence(async () => {
      const res = await checkPageId(pageId);
      return res;
    });
    if (res.code === 200) {
      const space = $spacesCache[res.data.spaceId];
      if (space) {
        switchSpaceViewIdBySpaceId(res.data.spaceId);
      }
    }
  }, []);
};
